module.exports = "<div class=col-md-7 ng-if=reviewTVM.thereIsDetails()> <div ng-include=\"'details-header-course'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=reviewTVM.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=reviewTVM.thereIsDetails() md-diameter=96> </md-progress-circular> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/consolidationCP/teachingDevelopment/listTeacherJobsView/course-details.html
// module id = 656
// module chunks = 0